import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Chip,
  TextField,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';

const API_URL = process.env.REACT_APP_API_URL;

const AiProgramAdminPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [rowCount, setRowCount] = useState(0);

  // ✅ Correct pagination state for MUI v6+
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/ai-program/admin-list/`, {
        params: {
          search,
          page: paginationModel.page + 1, // backend is 1-based
          page_size: paginationModel.pageSize,
        },
      });

      setRows(
        res.data.results.map((reg) => ({
          id: reg.registration_id,
          registration_id: reg.registration_id,
          user_name: reg.user?.name || 'N/A',
          email: reg.user?.email || 'N/A',
          contact: reg.user?.contact || 'N/A',
          demo_requested: reg.demo_requested,
          payment_confirmed: reg.payment_confirmed,
          created_at: new Date(reg.created_at).toLocaleString(),
          updated_at: new Date(reg.updated_at).toLocaleString(),
        }))
      );

      // ✅ MUST be total records count from backend
      setRowCount(res.data.total);
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Refetch on search or pagination change
  useEffect(() => {
    const delay = setTimeout(fetchData, 400); // debounce
    return () => clearTimeout(delay);
  }, [search, paginationModel]);

  const columns = [
    { field: 'registration_id', headerName: 'Registration ID', width: 220 },
    { field: 'user_name', headerName: 'Name', width: 180 },
    { field: 'email', headerName: 'Email', width: 220 },
    { field: 'contact', headerName: 'Contact', width: 150 },
    {
      field: 'demo_requested',
      headerName: 'Demo',
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <Chip label="Yes" color="success" size="small" />
        ) : (
          <Chip label="No" size="small" />
        ),
    },
    {
      field: 'payment_confirmed',
      headerName: 'Payment',
      width: 140,
      renderCell: (params) =>
        params.value ? (
          <Chip label="Paid" color="success" size="small" />
        ) : (
          <Chip label="Pending" color="warning" size="small" />
        ),
    },
    { field: 'created_at', headerName: 'Created At', width: 180 },
    { field: 'updated_at', headerName: 'Updated At', width: 180 },
  ];

  return (
    <Box sx={{ bgcolor: '#000', minHeight: '100vh', color: '#fff' }}>
      <Header1 />

      <Box sx={{ px: 3, py: 4 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          AI Program – Admin Dashboard
        </Typography>

        {/* 🔍 Search */}
        <TextField
          fullWidth
          placeholder="Search by name, email, contact, user ID..."
          variant="outlined"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPaginationModel((prev) => ({ ...prev, page: 0 }));
          }}
          sx={{
            mb: 3,
            bgcolor: '#1e1e1e',
            input: { color: '#fff' },
          }}
        />

        <Box sx={{ height: 620 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            loading={loading}
            rowCount={rowCount}
            paginationMode="server"
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[10, 20, 50]}
            sx={{
              bgcolor: '#1e1e1e',
              border: '1px solid #333',
              '.MuiDataGrid-columnHeaders': {
                bgcolor: '#181818',
                color: '#fff',
              },
              '.MuiDataGrid-cell': {
                borderBottom: '1px solid #2a2a2a',
                color: '#fff',
              },
            }}
          />
        </Box>
      </Box>

      <Footer2 />
    </Box>
  );
};

export default AiProgramAdminPage;
